//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { fetch, store, update } from '@/apis/mch'

import { oss_files } from '@/apis/config'


export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            mchName: [{ required: true, message: '請輸入名稱!' }],
            logo: [{ required: true, message: '請輸入名稱!' }],
            mchShortName: [{ required: true, message: '請輸入簡稱!' }],
            loginUserName: [{ required: true, message: '請輸入登錄賬戶名!' }],
            contactName: [{ required: true, message: '請輸入負責人聯系方式!' }],
            contactTel: [{ required: true, message: '請輸入負責人聯系方式!' }],
            contactEmail: [{ required: true, message: '請輸入負責人郵箱!' }],
            state: [{ required: true, message: '請選擇狀態!' }],

        };
        const formData = {
            "mchName": "",
            "logo": "",
            "mchShortName": "",
            "loginUserName": "",
            "contactName": "",
            "contactTel": "",
            "contactEmail": "",
            "remark": "",
            "state": "1"

        };
        return {
            id: "",
            fileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        if (this.id) {
            await this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 0) {
                    this.formData = res.data;
                    this.formData.state = this.formData.state.toString();
                    this.onLoadFile()
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            if (this.formData.logo) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(this.formData.logo),
                    status: 'done',
                    url: this.formData.logo,
                    thumbUrl: this.formData.logo,
                }]
            }
        },
        //圖片上傳
        async handleFileChange({ fileList }) {
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList.filter(file =>
                    file.type?.startsWith('image/') ||
                    (file.originFileObj && file.originFileObj.type.startsWith('image/'))
                );
                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files('ifBG', formData);

                    if (res.code == 0) {
                        this.formData.logo = res.data;
                        this.fileList = validFiles;
                        this.$refs.imageValidate.clearValidate();

                    } else {
                        this.$message.error(res.msg);
                    }
                    console.log(`output->this.formData`, this.formData)
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
                this.formData.logo = "";
            }
        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },
        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            let formFunction;
            const form = { ...this.formData };
            if (this.id) {
                form.id = this.id;
                formFunction = update;
            } else {
                formFunction = store;
            }
            try {
                this.spinning = true;
                const res = await formFunction(form);
                if (res.code == 0) {
                    this.$message.success('提交完成');
                    setTimeout(() => {
                        this.$router.push('/mch');
                    }, 2000)
                } else { 
                    this.$message.error(res.msg);    
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
